import { PERIOD } from "@/commons/enums";
import { AUCTION_TIME_GROUP, CHART_COLOR } from "@/features/home/enums";

export const getColorCodeList = (): Array<
  typeof CHART_COLOR[keyof typeof CHART_COLOR]["colorCode"]
> => {
  return [
    CHART_COLOR.RED["colorCode"],
    CHART_COLOR.AMBER["colorCode"],
    CHART_COLOR.YELLOW["colorCode"],
    CHART_COLOR.LIME["colorCode"],
    CHART_COLOR.LIGHT_GREEN["colorCode"],
    CHART_COLOR.CYAN["colorCode"],
    CHART_COLOR.BLUE["colorCode"],
    CHART_COLOR.INDIGO["colorCode"],
    CHART_COLOR.PURPLE["colorCode"],
    CHART_COLOR.PINK["colorCode"],
    CHART_COLOR.BLUE_GRAY["colorCode"],
  ];
};

export const getChartColorEnum = (
  value: number
): typeof CHART_COLOR[keyof typeof CHART_COLOR] | undefined => {
  switch (value) {
    case CHART_COLOR.RED["value"]:
      return CHART_COLOR.RED;
    case CHART_COLOR.AMBER["value"]:
      return CHART_COLOR.AMBER;
    case CHART_COLOR.YELLOW["value"]:
      return CHART_COLOR.YELLOW;
    case CHART_COLOR.LIME["value"]:
      return CHART_COLOR.LIME;
    case CHART_COLOR.LIGHT_GREEN["value"]:
      return CHART_COLOR.LIGHT_GREEN;
    case CHART_COLOR.CYAN["value"]:
      return CHART_COLOR.CYAN;
    case CHART_COLOR.BLUE["value"]:
      return CHART_COLOR.BLUE;
    case CHART_COLOR.INDIGO["value"]:
      return CHART_COLOR.INDIGO;
    case CHART_COLOR.PURPLE["value"]:
      return CHART_COLOR.PURPLE;
    case CHART_COLOR.PINK["value"]:
      return CHART_COLOR.PINK;
    case CHART_COLOR.BLUE_GRAY["value"]:
      return CHART_COLOR.BLUE_GRAY;
    default:
      return undefined;
  }
};

export const getTwentyTwoColorCodeList = (): Array<
  | typeof CHART_COLOR[keyof typeof CHART_COLOR]["colorCode"]
  | typeof CHART_COLOR[keyof typeof CHART_COLOR]["highlightColorCode"]
> => {
  return [
    CHART_COLOR.RED["colorCode"],
    CHART_COLOR.RED["highlightColorCode"],
    CHART_COLOR.AMBER["colorCode"],
    CHART_COLOR.AMBER["highlightColorCode"],
    CHART_COLOR.YELLOW["colorCode"],
    CHART_COLOR.YELLOW["highlightColorCode"],
    CHART_COLOR.LIME["colorCode"],
    CHART_COLOR.LIME["highlightColorCode"],
    CHART_COLOR.LIGHT_GREEN["colorCode"],
    CHART_COLOR.LIGHT_GREEN["highlightColorCode"],
    CHART_COLOR.CYAN["colorCode"],
    CHART_COLOR.CYAN["highlightColorCode"],
    CHART_COLOR.BLUE["colorCode"],
    CHART_COLOR.BLUE["highlightColorCode"],
    CHART_COLOR.INDIGO["colorCode"],
    CHART_COLOR.INDIGO["highlightColorCode"],
    CHART_COLOR.PURPLE["colorCode"],
    CHART_COLOR.PURPLE["highlightColorCode"],
    CHART_COLOR.PINK["colorCode"],
    CHART_COLOR.PINK["highlightColorCode"],
    CHART_COLOR.BLUE_GRAY["colorCode"],
    CHART_COLOR.BLUE_GRAY["highlightColorCode"],
  ];
};

export const getAuctionTimeGroupTextList = (): Array<
  typeof AUCTION_TIME_GROUP[keyof typeof AUCTION_TIME_GROUP]["text"]
> => {
  return [
    AUCTION_TIME_GROUP.TWO_HUNDRED["text"],
    AUCTION_TIME_GROUP.FOUR_HUNDRED["text"],
    AUCTION_TIME_GROUP.SIX_HUNDRED["text"],
    AUCTION_TIME_GROUP.EIGHT_HUNDRED["text"],
    AUCTION_TIME_GROUP.ONE_THOUSAND["text"],
    AUCTION_TIME_GROUP.ONE_THOUSAND_TWO_HUNDRED["text"],
    AUCTION_TIME_GROUP.ONE_THOUSAND_FOUR_HUNDRED["text"],
    AUCTION_TIME_GROUP.ONE_THOUSAND_SIX_HUNDRED["text"],
    AUCTION_TIME_GROUP.ONE_THOUSAND_EIGHT_HUNDRED["text"],
    AUCTION_TIME_GROUP.TWO_THOUSAND["text"],
    AUCTION_TIME_GROUP.TWO_THOUSAND_TWO_HUNDRED["text"],
    AUCTION_TIME_GROUP.TWO_THOUSAND_FOUR_HUNDRED["text"],
    AUCTION_TIME_GROUP.TWO_THOUSAND_SIX_HUNDRED["text"],
    AUCTION_TIME_GROUP.TWO_THOUSAND_EIGHT_HUNDRED["text"],
    AUCTION_TIME_GROUP.THREE_THOUSAND["text"],
  ];
};

// 4桁以上の number を「万」表記に変換して返す関数
export const convertToTenThousand = (value: number | string): string => {
  if (String(value).length > 4) return (Math.trunc(Number(value) / 1000) / 10).toString() + "万";
  else return String(value);
};

// 小数第二位を四捨五入した値を返す
export const round = (value: number): number => {
  return Math.round(value * 10) / 10;
};

// 期間選択が「日付指定」であるかどうか判定した結果を返す
export const isPeriodSpecification = (period: number): boolean => {
  return period === PERIOD.PERIOD_SPECIFICATION.value;
};
